import { HttpClient, provideHttpClient, withInterceptors } from '@angular/common/http';
import {
  type ApplicationConfig,
  inject,
  isDevMode,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideServiceWorker } from '@angular/service-worker';
import { dfAuthInterceptor } from '@digital-factory/df-design-system-v22';
import {
  provideNgIconLoader,
  provideNgIconsConfig,
  withCaching,
  withExceptionLogger,
} from '@ng-icons/core';
import { provideTanStackQuery, QueryClient } from '@tanstack/angular-query-experimental';
import { withDevtools } from '@tanstack/angular-query-experimental/devtools';
import { Amplify } from 'aws-amplify';
import { environment } from '../environments/environment';
import { routes } from './app.routes';

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: environment.aws.auth.userPoolId,
      userPoolClientId: environment.aws.auth.userPoolWebClientId,
      loginWith: {
        oauth: environment.aws.auth.oauth,
        username: false,
        email: false,
        phone: false,
      },
    },
  },
});

console.log('Amplify configured with Cognito user pool ID:', environment);

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(routes),
    provideHttpClient(withInterceptors([dfAuthInterceptor])),
    provideNgIconsConfig({}, withExceptionLogger()),
    provideNgIconLoader(
      (name) =>
        inject(HttpClient).get(`assets/svgs/${name}.svg`, {
          responseType: 'text',
        }),
      withCaching(),
    ),
    provideTanStackQuery(
      new QueryClient({
        defaultOptions: {
          queries: {
            refetchOnWindowFocus: false,
            gcTime: 1000 * 60 * 60 * 24, // 24 hours
            staleTime: 1000 * 60 * 60 * 2, // 2 hours
          },
        },
      }),
      withDevtools(),
    ),
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000',
    }),
  ],
};
